import React, { useState } from 'react';

// 🎯 viewMode와 setViewMode, 그리고 클릭 이벤트를 부모 및 다른 테이블들과 공유하기 위해 프롭으로 주입받습니다.
const MaintenanceContractTable = ({
    searchYear, 
    maintenanceDetailList = [], 
    forecastMaintenanceDetailList = [], 
    searchTerm = '',
    viewMode = 'actual',
    setViewMode,
    onProjectClick // 🎯 [추가] 유지보수명 클릭 시 부모 컴포넌트로 이벤트를 전달하는 핸들러
}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    // 선택된 토글 모드에 따라 유지보수 원본 데이터 소스를 동적으로 분기
    const activeList = viewMode === 'actual' ? maintenanceDetailList : forecastMaintenanceDetailList;

    // 주입받은 실시간 API 데이터를 선택된 모드에 맞춰 완벽 대응 및 가공
    const maintenanceItems = activeList.map((item, idx) => {
        const sales = Number(item.sales || 0);
        const cost = Number(item.buys || 0);
        const profit = Number(item.profit || 0);
        const margin = sales > 0 ? (profit / sales) * 100 : 0;

        let displayPeriod = '-';
        if (item.expDay || item.period) {
            const rawDate = String(item.expDay || item.period);
            displayPeriod = rawDate.includes('-') ? rawDate.substring(0, 7) : rawDate;
        }

        return {
            id: item.prjId || item.id || idx,
            name: item.cstNm || item.prjNm || item.name || '이름 없는 유지보수 계약',
            period: displayPeriod, 
            sales,
            cost,
            profit,
            margin,
            manager: item.usrNm || item.manager || '-',
            rawItem: item // 🎯 부모 컴포넌트의 공통 클릭 로직(formData 대입 로직)에 대응하기 위해 원본 저장
        };
    });

    const sortedItems = [...maintenanceItems].sort((a, b) => b.period.localeCompare(a.period));

    const filteredItems = sortedItems.filter(item => 
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const displayedItems = isExpanded ? filteredItems : filteredItems.slice(0, 3);

    const formatMonthlyCurrency = (value) => {
        return `₩ ${value.toLocaleString()}`;
    };

    return (
        <div style={{ width: '100%', boxSizing: 'border-box' }}>
            {/* 타이틀 및 우측 데이터 전환 버튼 영역 */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <h2 style={{ margin: 0, fontWeight: '700', fontSize: '14px', color: '#1f2937' }}>
                    {viewMode === 'actual' 
                        ? `${searchYear}년 유지보수(수주) 내역` 
                        : `${searchYear}년 유지보수(포캐스팅) 내역`
                    }
                </h2>
                
                <div style={{ display: 'flex', alignItems: 'center', height: '22px', border: '1px solid #0284c7', borderRadius: '4px', backgroundColor: '#ffffff', overflow: 'hidden' }}>
                    <button 
                        onClick={() => { setViewMode('actual'); setIsExpanded(false); }} 
                        style={{ padding: '0 10px', height: '100%', border: 'none', backgroundColor: viewMode === 'actual' ? '#e0f2fe' : 'transparent', fontSize: '11px', fontWeight: '700', color: '#0369a1', cursor: 'pointer', outline: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        수주 내역
                    </button>
                    <button 
                        onClick={() => { setViewMode('forecast'); setIsExpanded(false); }} 
                        style={{ padding: '0 10px', height: '100%', border: 'none', borderLeft: '1px solid #0284c7', backgroundColor: viewMode === 'forecast' ? '#e0f2fe' : 'transparent', fontSize: '11px', fontWeight: '700', color: '#0369a1', cursor: 'pointer', outline: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        포캐스팅
                    </button>
                </div>
            </div>

            {/* 테이블 컨테이너 */}
            <div style={{ width: '100%', overflowX: 'auto', border: '1px solid #d1d5db', borderRadius: '6px', backgroundColor: '#ffffff' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '13px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#e0f2fe', borderBottom: '1px solid #d1d5db', color: '#374151' }}>
                            <th style={{ padding: '8px 16px', fontWeight: '600' }}>유지보수명</th>
                            <th style={{ padding: '8px 16px', fontWeight: '600', width: '110px' }}>매출월</th>
                            <th style={{ padding: '8px 16px', fontWeight: '600', textAlign: 'right', width: '140px' }}>매출액</th>
                            <th style={{ padding: '8px 16px', fontWeight: '600', textAlign: 'right', width: '140px' }}>매입액</th>
                            <th style={{ padding: '8px 16px', fontWeight: '600', textAlign: 'right', width: '140px' }}>이익액</th>
                            <th style={{ padding: '8px 16px', fontWeight: '600', textAlign: 'right', width: '90px' }}>이익률</th>
                            <th style={{ padding: '8px 16px', fontWeight: '600', textAlign: 'center', width: '100px' }}>담당자</th>
                        </tr>
                    </thead>
                    <tbody style={{ color: '#4b5563' }}>
                        {displayedItems.map((item, index) => (
                            <tr 
                                key={item.id} 
                                style={{ 
                                    borderBottom: (index === displayedItems.length - 1 && (isExpanded || filteredItems.length <= 3)) ? 'none' : '1px solid #e5e7eb',
                                    backgroundColor: '#ffffff'
                                }}
                            >
                                {/* 🎯 [교정] 유지보수명 클릭 이벤트 탑재 및 기본 상시 언더라인 스타일 세팅 */}
                                <td style={{ padding: '6px 16px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '300px' }}>
                                    <span 
                                        onClick={() => onProjectClick && onProjectClick(item)}
                                        style={{ 
                                            color: '#0284c7', 
                                            cursor: 'pointer', 
                                            fontWeight: '500', 
                                            fontSize: '13px',
                                            textDecoration: 'underline' // 기본 상태에서 항시 밑줄 표시
                                        }}
                                    >
                                        {item.name}
                                    </span>
                                </td>
                                <td style={{ padding: '6px 16px', fontWeight: '500', color: '#1f2937', whiteSpace: 'nowrap' }}>
                                    {item.period}
                                </td>
                                <td style={{ padding: '6px 16px', textAlign: 'right', fontWeight: '500', color: '#374151', whiteSpace: 'nowrap' }}>
                                    {formatMonthlyCurrency(item.sales)}
                                </td>
                                <td style={{ padding: '6px 16px', textAlign: 'right', fontWeight: '500', color: '#ea580c', whiteSpace: 'nowrap' }}>
                                    {formatMonthlyCurrency(item.cost)}
                                </td>
                                <td style={{ padding: '6px 16px', textAlign: 'right', fontWeight: '700', color: '#16a34a', whiteSpace: 'nowrap' }}>
                                    {formatMonthlyCurrency(item.profit)}
                                </td>
                                <td style={{ padding: '6px 16px', textAlign: 'right', fontWeight: '600', color: '#4b5563', whiteSpace: 'nowrap' }}>
                                    {item.margin.toFixed(1)}%
                                </td>
                                <td style={{ padding: '6px 16px', fontWeight: '500', textAlign: 'center', color: '#1f2937', whiteSpace: 'nowrap' }}>
                                    {item.manager}
                                </td>
                            </tr>
                        ))}
                        
                        {filteredItems.length > 3 && (
                            <tr 
                                onClick={() => setIsExpanded(!isExpanded)}
                                style={{ backgroundColor: '#ffffff', cursor: 'pointer', transition: 'background-color 0.15s' }}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f8fafc'}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
                            >
                                <td colSpan="7" style={{ padding: '4px 16px', fontSize: '11px', fontWeight: '500', color: '#94a3b8', textAlign: 'center', userSelect: 'none' }}>
                                    {isExpanded ? '접기 ▲' : `유지보수 내역 펼치기 (총 ${filteredItems.length}개 항목) ▼`}
                                </td>
                            </tr>
                        )}

                        {filteredItems.length === 0 && (
                            <tr>
                                <td colSpan="7" style={{ padding: '16px', textAlign: 'center', color: '#9ca3af' }}>
                                    {viewMode === 'actual' ? '당해년도 유지보수 내역이 없습니다.' : '당해년도 포캐스팅 내역이 없습니다.'}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MaintenanceContractTable;
